import get from 'get-value';
export var adaptOnChangeEvent = function adaptOnChangeEvent(event, target) {
  return get(target, 'checked');
};